module.exports = __webpack_public_path__ + "media/images/salon-cbf6704641dee6274b7ba48d6e3ca97e.svg";